import { useMutation } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { updateCacheByType } from '../../../graphql/GraphQlProvider';
import { GroupBooking } from '../../../graphql/groups.datatypes';
import { gqlGroupBooking } from '../getGroupBooking.api';

export interface UpdateGroupBookingInput {
  data: {
    id: number
    group_id?: number
    start_date?: string
    end_date?: string
    disabled?: boolean
    soft_cancelled?: boolean
  }
}

interface UpdateGroupBookingData {
  __typename?: string,
  updateGroupBooking: GroupBooking
}

export const UPDATE_BILLING_PARTY_MUTATION = gql`
    mutation updateGroupBooking($data: UpdateGroupBookingInput!) {
        updateGroupBooking(data: $data) {
            ${gqlGroupBooking}
        }
    }
`;

export const updateGroupBooking = () => useMutation<UpdateGroupBookingData, UpdateGroupBookingInput>(
  UPDATE_BILLING_PARTY_MUTATION,
  {
    update: updateCacheByType('GroupBooking'),
  }
);

export default updateGroupBooking;